import { CATEGORIAS_DOCUMENTO } from '@/core/types/documentos'

/**
 * Nombre de pila del cliente para el saludo de los mails de presentación (ORR-176).
 * `cliente_nombre` llega de la vista de vencimientos como "Apellido, Nombre" (personas
 * físicas): tomamos lo que está tras la primera coma = nombre(s) de pila. Las jurídicas
 * (razón social, sin coma) se devuelven tal cual.
 */
export function primerNombreCliente(clienteNombre: string): string {
  const i = clienteNombre.indexOf(',')
  return (i === -1 ? clienteNombre : clienteNombre.slice(i + 1)).trim()
}

/**
 * Nombre del adjunto de presentación: "{tipo} - {impuesto} - {período} - {cliente}.ext"
 * (ORR-179; período agregado en ORR-190). `tipo` = label de la categoría
 * (DDJJ/Acuse/VEP...), o la descripción libre cuando la categoría es 'otros'. La extensión
 * original se conserva. El cliente se normaliza reemplazando la coma de "Apellido, Nombre"
 * por un espacio. El período se sanitiza ("/" → "-", rompe nombres de archivo) y se omite
 * el placeholder "—" de formatPeriodo cuando no hay período.
 */
export function construirNombreAdjunto(
  fileName: string,
  categoria: string,
  descripcion: string | undefined,
  tipoImpuesto: string,
  clienteNombre: string,
  periodo?: string,
): string {
  const tipo =
    categoria === 'otros'
      ? descripcion?.trim() || 'Documento'
      : CATEGORIAS_DOCUMENTO[categoria]?.label ?? categoria
  const dot = fileName.lastIndexOf('.')
  const ext = dot > 0 ? fileName.slice(dot) : ''
  const cliente = clienteNombre.replace(/,\s*/g, ' ').trim()
  const periodoLimpio = (periodo ?? '').replace(/\//g, '-').trim()
  const periodoSafe = periodoLimpio === '—' ? '' : periodoLimpio
  return [tipo, tipoImpuesto.trim(), periodoSafe, cliente].filter(Boolean).join(' - ') + ext
}
